<div class="u8_bind_component" v-if="excelBindData!=null">
    <div class="dialog" :class="{hiden_dialog: excelBindData===null }">
        <div class="dialog_background" @click="$emit('closebind')"></div>
        <div class="dialog_container u8_bind_container">
            <div class="dialog_content">
                <div class="dialog_header">
                    <div class="dialog_small_title">
                        <span class="notice">{{ $t('notice') }}：</span>{{ $t('unboundProduct') }}
                    </div>
                </div>
                <div class="bind_tables">
                    <div class="mdc-data-table">
                        <div class="mdc-data-table__table-container">
                            <table class="mdc-data-table__table" aria-label="Dessert calories">
                                <thead>
                                    <tr class="mdc-data-table__header-row">
                                        <th class="mdc-data-table__header-cell bind_table_title" role="columnheader"
                                            scope="col">{{ $t('thirdCode') }}</th>
                                        <th class="mdc-data-table__header-cell bind_table_title" role="columnheader"
                                            scope="col">{{ $t('u8StockCode') }}</th>
                                        <th class="mdc-data-table__header-cell" role="columnheader" scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody class="mdc-data-table__content">
                                    <tr class="mdc-data-table__row" v-for="(value, index) in excelBindData.bindDevice"
                                        :key="index">
                                        <th class="mdc-data-table__cell" scope="row">{{value}}</th>
                                        <td class="mdc-data-table__cell" :id="'bind_device_'+index">{{ $t('unbound') }}</td>
                                        <td class="mdc-data-table__cell">
                                            <div class="mdc-icon-button material-icons"
                                                @click="showBindData(index, value)">keyboard_arrow_right</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="dialog_note">{{ $t('unboundNotic') }}</div>
                </div>
                <div class="dialog_footer_action">
                    <button class="mdc-button mdc-button--outlined dialog_action_button_size"
                        @click="$emit('closebind')">
                        <div class="mdc-button__ripple"></div>
                        <span class="mdc-button__label">{{ $t('cancel') }}</span>
                    </button>
                    <button id="submitButton" class="mdc-button mdc-button--raised dialog_action_button_size right"
                        disabled @click="commitBindData">
                        <span class="mdc-button__label">{{ $t('upload') }}</span>
                    </button>
                </div>
            </div>
            <div class="bind_data" :class="{show: isShowBindData}">
                <div class="bind_data_name" v-for="(value, index) in excelBindData.optionDevice" :key="index"
                    @click="selectedBindData(value)" :id="'bind_option_name_'+value.id">{{value.code}}
                    {{value.productName}}</div>
            </div>
        </div>
    </div>

</div>
